import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import Claim from "./pages/Claim";
import Layout from "./Layout/Layout";
import HomePage from "./pages/HomePage";
import Overview from "./pages/Overview";
import UserRoute from "./Layout/UserRoute";
import Governance from "./pages/Governance";

function Routers() {
  const route = [
    {
      path: "/overview",
      component: <Overview />,
    },
    {
      path: "/governance/claim",
      component: <Claim />,
    },
    {
      path: "/governance/:config",
      component: <Governance />,
    },
    {
      path: "*",
      component: <Navigate to="/" />,
    },
  ];

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<HomePage />}></Route>
        {route?.map((m, i) => (
          <Route
            path={m.path}
            key={i}
            element={<UserRoute>{m.component}</UserRoute>}
          ></Route>
        ))}
      </Routes>
    </Layout>
  );
}

export default Routers;
